import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col} from 'react-bootstrap';
import Article from './index';
import {dateFormat} from '../../../utils/commonFunctions'

class ArticleList extends Component {

  render() {
    return (
      <div className="news-articles-container">
        {this.props.articles.map((key) => {
          return (
            <Article
              key={key.id}
              id={key.id}
              image={key.attributes.link.image}
              title={key.attributes.title}
            />
          );
        })}
      </div>
    );
  }
}

ArticleList.propTypes = {
  articles: PropTypes.array.isRequired
};

export default ArticleList;



// WEBPACK FOOTER //
// ./src/components/common/article/article-list.jsx